import gql from 'graphql-tag';

export const getAccount = gql`
  query {
    getAccount {
      type
      avatar {
        mediaId
        url
      }
      username
      email
      address
      phone
      birthday
      webhookAlertURL
      webhookDeviceSiteURL
      webhookCustomerAlertURL
    }
  }
`
